import { login, logout } from '@/api/app';
import { getJwt, getMyInfo, getPermission, setJwt, setMyInfo, setPermission } from './user.service';

export default {
    namespaced: true,
    state: {
        myInfo: getMyInfo(),
        token: getJwt(),
        access: getPermission(),
    },
    mutations: {
        setAccess(state, access) {
            state.access = access;
            setPermission(access);
        },
        setToken(state, token) {
            state.token = token;
            setJwt(token);
        },
        setMyInfo(state, info) {
            state.myInfo = info;
            setMyInfo(info);
        },
    },
    actions: {
        // 登录
        async handleLogin({ commit }, { loginName, password, captcha, captchaKey }) {
            loginName = loginName.trim();
            const res = await login({ loginName, password, captcha }, captchaKey);
            commit('setToken', res.jwt);
            commit('setMyInfo', res.user);
            commit('setAccess', res.authority);
        },
        // 退出登录
        async handleLogOut({ state, commit }) {
            //await logout(state.token);
            try{
              await logout(state.token);
            }catch(error){
               // console.log("logout...");
            }
            commit('setToken', '');
            commit('setAccess', []);
        },
    },
};
